import React, { useState, useRef, useEffect } from 'react';
import { API } from 'aws-amplify';
import { updateClientUser } from '../../graphql/mutations';
import {AmplifyS3Image} from "@aws-amplify/ui-react";
import {AmplifyS3ImagePicker} from "@aws-amplify/ui-react";
import jBox from 'jbox'
import 'jbox/dist/jBox.all.css';

import Image from '../../images/user-avatar-80.png';

function WebPushProfile({userDetails, authToken, logout}) {

  const [sync, setSync] = useState(false);
  const deleteBtnRef = useRef()
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [editImage, setEditImage] = useState(false)
  const [webPushSubLink, setWebPushSubLink] = useState('')

  const [alias, setAlias] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    if(userDetails.webPushAlias!=null) {
      setAlias(userDetails.webPushAlias)
    }
    if(userDetails.webPushDescription!=null) {
      setDescription((userDetails.webPushDescription))
    }
    if(userDetails!=null && userDetails!=undefined)
      if('webPushSubLink' in userDetails && userDetails.webPushSubLink!=null
        && userDetails.webPushSubLink!=undefined && userDetails.webPushSubLink!=' '){
        setWebPushSubLink(userDetails.webPushSubLink)
      }
      else{
        const apiName = 'DashboardAPI'; // replace this with your api name.
        const path = '/web-push/manage-sub'; //replace this with the path you have configured on your API
        const myInit = {
          queryStringParameters: {
            id: userDetails.id,
            token: '',
            task: 'createSubLink'
          }
        };
        API
          .get(apiName, path, myInit)
          .then(response => {
            if(response['success']){
              userDetails.webPushSubLink = response['webPushSubLink']
              setWebPushSubLink(response['webPushSubLink'])
            }
            else{
              new jBox('Notice', {content: 'Woops. Could not retrieve your unique subscription link. Try again later.',
                color: 'red', position: {x: 'center', y: 20}});
            }
          })
          .catch(error => {
            console.log('Error executing request.')
            console.log(error)
          });

      }

  }, []);

  function aliasChange(e){
    setAlias(e.target.value)
  }

  function descriptionChange(e){
    setDescription(e.target.value)
  }

  function fileToKey(obj){
    new jBox('Notice', {content: 'Profile image saved.', color: 'green', position: {x: 'center', y: 20}});
    loadingImage()
    return 'webPushProfileImages/'+userDetails.id
  }

  function loadingImage(){
    setTimeout(function() { //Start the timer
      setEditImage(false)
    }.bind(this), 1000)
  }

  async function saveDetails(){
    if(userDetails.id != null) {
      userDetails.webPushAlias = alias
      userDetails.webPushDescription = description
      const details = {
        id: userDetails.id,
        webPushAlias: alias,
        webPushDescription: description
      }
      const updatedClientUser = await API.graphql({
        query: updateClientUser,
        variables: {input: details}
      });
      new jBox('Notice', {content: 'Changes saved.', color: 'green', position: {x: 'center', y: 20}});
    }
  }

  function copyToClipboard(){
    if (webPushSubLink!=''){
      const el = document.createElement("textarea");
      el.value = webPushSubLink;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      el.setSelectionRange(0, 99999);
      document.execCommand("copy");
      document.body.removeChild(el);
      new jBox('Notice', {content: 'Link copied!',
        color: 'blue', position: {x: 'center', y: 'center'}});
    }
  }

  return (
    <div className="flex-grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <h2 className="text-2xl text-gray-800 font-bold mb-5">Subscribe Profile</h2>

        <section>
            <div className="text-sm max-w-md" style={{"textAlign": "justify"}}>These details are used to populate your web push subscription page. Your subscription page is where your
            audience can subscribe to your Web Push-notifications. Your subscription page will be public, so be mindful
            what you include. You can share your unique subscription link to help your audience find you:</div>
          <div className="grid max-w-md mt-4 justify-items-center">
            <div className="flex">

              <a href={"https://"+webPushSubLink} target="_blank">
                <svg  className="w-6 h-6 flex-shrink-0 fill-current mr-2" viewBox="0 0 20 20">
                  <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z"></path>
                </svg>
              </a>
              <div className="point" onClick={copyToClipboard}>
                <svg className="w-6 h-6 flex-shrink-0 fill-current mr-2" viewBox="0 0 20 20">
                  <path
                    d="M17.391,2.406H7.266c-0.232,0-0.422,0.19-0.422,0.422v3.797H3.047c-0.232,0-0.422,0.19-0.422,0.422v10.125c0,0.232,0.19,0.422,0.422,0.422h10.125c0.231,0,0.422-0.189,0.422-0.422v-3.797h3.797c0.232,0,0.422-0.19,0.422-0.422V2.828C17.812,2.596,17.623,2.406,17.391,2.406 M12.749,16.75h-9.28V7.469h3.375v5.484c0,0.231,0.19,0.422,0.422,0.422h5.483V16.75zM16.969,12.531H7.688V3.25h9.281V12.531z"></path>
                </svg>
              </div>
              <div className="col-md-5"><p className="text-sm">{"https://"+webPushSubLink}</p></div>
            </div>
          </div>

        </section>
        {/* Picture */}
        <section>
          <div className="flex items-center">
            <div className="mr-4">
              {!editImage?<AmplifyS3Image className="w-20 h-20 rounded-full" width="80" height="80" alt={"Upload a Profile Image"}
                               imgKey={'webPushProfileImages/'+userDetails.id} level={"public"}/>:
                <div>
                  <AmplifyS3ImagePicker level={"public"} fileToKey={fileToKey} />
                </div>}
            </div>
            {!editImage?<button className="btn-sm bg-pink-500 hover:bg-pink-600 text-white" onClick={() => {
              setEditImage(true)
            }}>Edit</button>:<button className="btn-sm bg-pink-500 hover:bg-pink-600 text-white" onClick={() => {
              setEditImage(false)
            }}>Cancel</button>}
          </div>
        </section>
        {/* Username */}
        <section>
          <h2 className="text-xl leading-snug text-gray-800 font-bold mb-1">Alias</h2>
          <div className="text-sm">The alias with which your audience identifies you.</div>
          <div className="flex flex-wrap mt-5">
            <div className="mr-2">
              <label className="sr-only" htmlFor="email">Alias</label>
              <input id="alias" className="form-input" type="text" value={alias}
              onChange={aliasChange}/>
            </div>
          </div>
        </section>
        {/* Description */}
        <section>
          <h2 className="text-xl leading-snug text-gray-800 font-bold mb-1">Description</h2>
          <div className="text-sm">You can add additional text here describing your profile.</div>
          <div className="flex flex-wrap mt-5 sm:w-1/3">
            <label className="sr-only" htmlFor="description">Leave a feedback</label>
            <textarea id="description" className="form-textarea focus:border-gray-300 w-full" rows="4"
                      placeholder="I really enjoy…" value={description} onChange={descriptionChange} ></textarea>
          </div>
        </section>
      </div>
      {/* Panel footer */}
      <footer>
        <div className="flex flex-col px-6 py-5 border-t border-gray-200">
          <div className="flex self-end">
            <button className="btn bg-pink-500 hover:bg-pink-600 text-white ml-3" onClick={saveDetails}>Save Changes</button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default WebPushProfile;